import React, { FC } from "react";
import classes from "./SelectProductItemsHeader.module.scss";
import { SaveButton } from "../../../uikit/atoms/buttons/SaveButton";
import { CancelButton } from "../../../uikit/atoms/buttons/CancelButton";
import { CommonButton } from "../../../uikit/atoms/buttons/CommonButton";
import { useRecoilState } from "recoil";
import { userState } from "../../../../states/userState";
import { User } from "../../../types/user";
import { setUserToLocalStorage } from "../../../../functions/localStorageManager";
import { getDefaultCheckedItems } from "../../../../commons/productItems";
type Props = {
  setIsShow: (value: boolean) => void;
  checkedItems: Number[];
  setCheckedItems: React.Dispatch<React.SetStateAction<Number[]>>;
};
const SelectProductItemsHeader: FC<Props> = (props) => {
  const { setIsShow, checkedItems, setCheckedItems } = props;
  const [user, setUser] = useRecoilState(userState);
  const handleSaveButtonClick = () => {
    setUser((prevState: User) => {
      const updatedUser = {
        ...prevState,
        filters: {
          ...prevState.filters,
          productItem: checkedItems,
        },
      };
      setUserToLocalStorage(updatedUser);
      return updatedUser;
    });
    setIsShow(false);
  };
  const handleSelectAllButtonClick = () => {
    setCheckedItems(getDefaultCheckedItems(user.viewId));
  };
  const handleClearButton = () => {
    setCheckedItems([]);
  };
  return (
    <div className={classes.rootContainer}>
      <div className={classes.leftContent}>
        <div>
          <CommonButton
            disabled={false}
            caption={"全部"}
            onClick={handleSelectAllButtonClick}
          />
        </div>
        <div>
          <CommonButton
            disabled={false}
            caption={"クリア"}
            onClick={handleClearButton}
          />
        </div>
      </div>
      <div className={classes.rightContent}>
        <div>
          <SaveButton
            disabled={checkedItems.length === 0}
            onClick={handleSaveButtonClick}
            caption={"Save Visibilities"}
          />
        </div>
        <div>
          <CancelButton
            disabled={false}
            onClick={() => setIsShow(false)}
            caption={"Cancel"}
          />
        </div>
      </div>
    </div>
  );
};

export default SelectProductItemsHeader;
